/* Laska Studio — timeline de la méthode + dossier à onglets des projets */
(function () {
  'use strict';

  /* ---------- Timeline : jauge au scroll + étapes qui s'allument ---------- */
  var timelines = [];

  function initTimeline(hote) {
    if (hote.dataset.lkReady) return;
    hote.dataset.lkReady = '1';

    var etapes = Array.prototype.slice.call(hote.querySelectorAll('[data-etape]'));
    var jauge = hote.querySelector('[data-jauge]');
    if (!etapes.length) return;

    var allumer = function (el) { el.classList.add('is-on'); };

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) { if (e.isIntersecting) allumer(e.target); });
      }, { rootMargin: '0px 0px -42% 0px', threshold: 0.1 });
      etapes.forEach(function (el) { obs.observe(el); });
    } else {
      etapes.forEach(allumer);
    }

    timelines.push({ hote: hote, etapes: etapes, jauge: jauge });
    majTimelines();
  }

  function majTimelines() {
    var cible = window.innerHeight * 0.58;
    timelines = timelines.filter(function (t) { return document.body.contains(t.hote); });
    timelines.forEach(function (t) {
      if (t.jauge) {
        var boite = t.hote.getBoundingClientRect();
        var ratio = Math.max(0, Math.min(1, (cible - boite.top) / Math.max(1, boite.height)));
        t.jauge.style.height = (ratio * 100) + '%';
      }
      t.etapes.forEach(function (el) {
        if (el.getBoundingClientRect().top < cible) el.classList.add('is-on');
      });
    });
  }

  var enAttente = false;
  window.addEventListener('scroll', function () {
    if (enAttente) return;
    enAttente = true;
    window.requestAnimationFrame(function () { enAttente = false; majTimelines(); });
  }, { passive: true });
  window.addEventListener('resize', majTimelines);

  /* ---------- Dossier à onglets ---------- */
  function initDossier(dossier) {
    if (dossier.dataset.lkReady) return;
    dossier.dataset.lkReady = '1';

    var onglets = Array.prototype.slice.call(dossier.querySelectorAll('[role="tab"]'));

    var ouvrir = function (onglet, focus) {
      onglets.forEach(function (o) {
        var actif = o === onglet;
        o.setAttribute('aria-selected', actif ? 'true' : 'false');
        o.tabIndex = actif ? 0 : -1;
        var panneau = document.getElementById(o.getAttribute('aria-controls'));
        if (panneau) panneau.hidden = !actif;
      });
      if (focus) onglet.focus();
    };

    onglets.forEach(function (o, i) {
      o.addEventListener('click', function () { ouvrir(o, false); });
      o.addEventListener('keydown', function (e) {
        var cible = null;
        if (e.key === 'ArrowRight') cible = onglets[(i + 1) % onglets.length];
        if (e.key === 'ArrowLeft') cible = onglets[(i - 1 + onglets.length) % onglets.length];
        if (e.key === 'Home') cible = onglets[0];
        if (e.key === 'End') cible = onglets[onglets.length - 1];
        if (cible) { e.preventDefault(); ouvrir(cible, true); }
      });
    });
  }

  /* ---------- Flux Instagram (JSON Behold) ---------- */
  function initInsta(grille) {
    if (grille.dataset.lkReady) return;
    grille.dataset.lkReady = '1';

    var nombre = parseInt(grille.dataset.count, 10) || 6;
    var carte = grille.closest('.lk-insta');
    var icone = carte && carte.querySelector('.lk-insta__avatar svg');

    fetch(grille.dataset.lkInsta)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (donnees) {
        var posts = Array.isArray(donnees) ? donnees : (donnees && donnees.posts) || [];
        posts = posts.slice(0, nombre);
        if (!posts.length) return;

        grille.textContent = '';
        posts.forEach(function (p) {
          var tailles = p.sizes || {};
          var src = (tailles.medium && tailles.medium.mediaUrl)
            || (p.mediaType === 'VIDEO' ? p.thumbnailUrl : p.mediaUrl)
            || p.thumbnailUrl;
          if (!src) return;

          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = p.permalink || grille.dataset.profil;
          a.target = '_blank';
          a.rel = 'noopener';

          var img = document.createElement('img');
          img.src = src;
          img.loading = 'lazy';
          img.alt = (p.prunedCaption || p.caption || 'Publication Instagram de Laska Studio').slice(0, 120);
          a.appendChild(img);

          var survol = document.createElement('span');
          survol.className = 'lk-insta__hover';
          survol.setAttribute('aria-hidden', 'true');
          if (icone) survol.appendChild(icone.cloneNode(true));
          a.appendChild(survol);

          li.appendChild(a);
          grille.appendChild(li);
        });
      })
      .catch(function () { /* en cas d'échec, on garde les publications choisies à la main */ });
  }

  /* ---------- Instafeed : on récupère ses publications pour les afficher en une rangée ---------- */
  function initInstafeed(hote) {
    if (hote.dataset.lkReady) return;
    hote.dataset.lkReady = '1';

    var grille = hote.nextElementSibling;
    var nombre = parseInt(hote.dataset.count, 10) || 6;
    var carte = hote.closest('.lk-insta');
    var icone = carte && carte.querySelector('.lk-insta__avatar svg');
    var minuterie = null;
    var tentative = 0;

    var premiereUrl = function (srcset) {
      return srcset ? srcset.split(',')[0].trim().split(' ')[0] : '';
    };

    var source = function (el) {
      if (el.tagName === 'IMG' || el.tagName === 'SOURCE') {
        // Les images différées (lazy-load) gardent leur vraie adresse dans des attributs data-*
        var candidats = [
          el.dataset.src, el.dataset.lazySrc, el.dataset.original,
          premiereUrl(el.dataset.srcset), premiereUrl(el.getAttribute('srcset')),
          el.currentSrc, el.getAttribute('src')
        ];
        for (var i = 0; i < candidats.length; i++) {
          if (candidats[i] && candidats[i].indexOf('data:') !== 0) return candidats[i];
        }
        return '';
      }
      var fond = el.style.backgroundImage || window.getComputedStyle(el).backgroundImage || '';
      var m = fond.match(/url\(["']?(.*?)["']?\)/);
      return m && m[1].indexOf('data:') !== 0 ? m[1] : '';
    };

    var reconstruire = function () {
      var vus = {};
      var items = [];
      hote.querySelectorAll('img, [style*="background-image"], [data-bg], [data-background]').forEach(function (el) {
        if (el.closest('header, [class*="header"], [class*="profile"], [class*="avatar"]')) return;
        if (!source(el) && (el.dataset.bg || el.dataset.background)) {
          el.style.backgroundImage = 'url(' + (el.dataset.bg || el.dataset.background) + ')';
        }
        var src = source(el);
        if (!src || src.indexOf('data:') === 0 || vus[src]) return;
        var lien = el.closest('a');
        vus[src] = true;
        items.push({ src: src, href: lien && lien.href ? lien.href : hote.dataset.profil, alt: el.getAttribute('alt') || '' });
      });
      if (!grille || items.length < 2) return false;

      // On ne garde que les images qui se chargent vraiment (pas d'icône, de pixel ou de lien cassé)
      var essai = ++tentative;
      var verifs = items.slice(0, nombre * 2).map(function (it) {
        return new Promise(function (ok) {
          var test = new Image();
          test.onload = function () { ok(test.naturalWidth >= 80 ? it : null); };
          test.onerror = function () { ok(null); };
          test.src = it.src;
        });
      });
      Promise.all(verifs).then(function (res) {
        if (essai !== tentative) return;
        var valides = res.filter(Boolean).slice(0, nombre);
        if (valides.length < 2) return;

        grille.textContent = '';
        valides.forEach(function (it) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = it.href;
          a.target = '_blank';
          a.rel = 'noopener';
          var img = document.createElement('img');
          img.src = it.src;
          img.loading = 'lazy';
          img.alt = it.alt || 'Publication Instagram de Laska Studio';
          a.appendChild(img);
          var survol = document.createElement('span');
          survol.className = 'lk-insta__hover';
          survol.setAttribute('aria-hidden', 'true');
          if (icone) survol.appendChild(icone.cloneNode(true));
          a.appendChild(survol);
          li.appendChild(a);
          grille.appendChild(li);
        });
        grille.hidden = false;
        hote.classList.add('is-repris');
      });
      return true;
    };

    var obs = new MutationObserver(function () {
      clearTimeout(minuterie);
      minuterie = setTimeout(reconstruire, 400);
    });
    obs.observe(hote, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'style'] });
    setTimeout(function () { obs.disconnect(); }, 60000);
    reconstruire();
  }

  /* ---------- Carrousel Instagram ---------- */
  function initCarrousel(carte) {
    if (carte.dataset.lkCarrouselReady) return;
    carte.dataset.lkCarrouselReady = '1';

    var nav = carte.querySelector('.lk-insta__nav');
    var boutons = Array.prototype.slice.call(carte.querySelectorAll('.lk-insta__fleche'));
    var grille = function () {
      var g = carte.querySelectorAll('.lk-insta__grid');
      for (var i = 0; i < g.length; i++) { if (!g[i].hidden) return g[i]; }
      return null;
    };

    var maj = function () {
      var g = grille();
      var defile = g && g.scrollWidth > g.clientWidth + 4;
      if (nav && nav.hidden !== !defile) nav.hidden = !defile; // évite de relancer l'observateur en boucle
      if (!defile) return;
      boutons[0].disabled = g.scrollLeft <= 4;
      boutons[1].disabled = g.scrollLeft + g.clientWidth >= g.scrollWidth - 4;
    };

    boutons.forEach(function (b) {
      b.addEventListener('click', function () {
        var g = grille();
        if (g) g.scrollBy({ left: parseInt(b.dataset.sens, 10) * g.clientWidth, behavior: 'smooth' });
      });
    });

    carte.addEventListener('scroll', maj, true);
    window.addEventListener('resize', maj);
    new MutationObserver(maj).observe(carte, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    maj();
  }

  /* ---------- Avis longs : bouton « Lire tout l'avis » ---------- */
  function initAvis(texte) {
    if (texte.dataset.lkReady) return;
    texte.dataset.lkReady = '1';
    var carte = texte.closest('.lk-quote');
    var bouton = carte && carte.querySelector('.lk-quote__more');
    if (!bouton) return;

    var verifier = function () {
      if (carte.classList.contains('is-open')) return;
      bouton.hidden = texte.scrollHeight <= texte.clientHeight + 2;
    };
    bouton.addEventListener('click', function () {
      var ouvert = carte.classList.toggle('is-open');
      bouton.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      bouton.textContent = ouvert ? bouton.dataset.moins : bouton.dataset.plus;
    });
    window.addEventListener('resize', verifier);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(verifier);
    verifier();
  }

  /* ---------- Surlignage jaune déclenché à l'arrivée à l'écran ---------- */
  var obsSurligne = 'IntersectionObserver' in window ? new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-vue'); obsSurligne.unobserve(e.target); }
    });
  }, { threshold: 0.8 }) : null;

  function initSurligne(el) {
    if (el.dataset.lkReady) return;
    el.dataset.lkReady = '1';
    if (obsSurligne) obsSurligne.observe(el); else el.classList.add('is-vue');
  }

  function init(racine) {
    (racine || document).querySelectorAll('[data-lk-surligne]').forEach(initSurligne);
    (racine || document).querySelectorAll('[data-lk-clamp]').forEach(initAvis);
    (racine || document).querySelectorAll('[data-lk-carrousel]').forEach(initCarrousel);
    (racine || document).querySelectorAll('[data-lk-instafeed]').forEach(initInstafeed);
    (racine || document).querySelectorAll('[data-lk-insta]').forEach(initInsta);
    (racine || document).querySelectorAll('[data-lk-timeline]').forEach(initTimeline);
    (racine || document).querySelectorAll('[data-lk-dossier]').forEach(initDossier);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Éditeur de thème : réinitialiser une section rechargée, ouvrir l'onglet du bloc sélectionné */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var onglet = document.querySelector('[role="tab"][data-block-id="' + e.detail.blockId + '"]');
    if (onglet) onglet.click();
  });
})();
